import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-info-menu',
  imports: [
    CommonModule,
    MatDialogModule
  ],
  template: `
  <div class="c-header-info__header">
    <span class="c-header-info__title">
      <img
        class="c-header-info__icon"
        src="assets/img/header/povos-da-floresta-portal-de-gestao-logo.svg"
      />
      PLACEHOLDER
    </span>
    <span class="c-header-info__close">
      <img
        src="assets/img/close-icon--gray.svg"
        alt="close"
        (click)="close()"
      />
    </span>
  </div>
  <mat-dialog-content>
  <div class="wrapper-info">
    <section class="textjustify">

    </section>
  </div>
  </mat-dialog-content>
  `,
  styles: `
    .c-header-info {
    width: 800px;
    height: 800px;

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #FFFFFF;
      width: 100%;
      height: 40px;
      padding-left: 10px;
      padding-right: 14px;
      border-radius: 8px 8px 0px 0px;
      box-sizing: border-box;
      /* border-bottom: 3px solid #000; */
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
    }

    &__icon {
      width: 24px;
      margin-right: 10px;
    }

    &__title {
      font-family: Open Sans;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      display: flex;
      align-items: center;
      color: var(--app-neutral-dark-color);
    }

    &__close {
      display: flex;
      align-items: center;
      color: var(--app-neutral-dark-color);
      cursor: pointer;
    }
  }

  .wrapper-info {
    padding: 8px 20px;
  }

  .textjustify{
    text-align: justify;
    line-height: 1.5;
  }

  :host ::ng-deep {
    .mat-mdc-dialog-content {
      margin: 5px 0px !important;
    }
  }
  `
})
export class ProjectInformationDialogComponent {
  version: string = "1.0.0";

  constructor(
    // private readonly utilsService: UtilsService,
    public dialogRef: MatDialogRef<ProjectInformationDialogComponent>,
  ){}

  ngOnInit(): void {
    // this.version = this.utilsService.getAppVersion();
  }

  close() {
    this.dialogRef.close();
  }

}
